import { render, staticRenderFns } from "./PrintFacturaSimplificada.vue?vue&type=template&id=4f1d12a7&"
import script from "./PrintFacturaSimplificada.vue?vue&type=script&lang=js&"
export * from "./PrintFacturaSimplificada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports